import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_ECU",
  "use": "icon-icon_ECU-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_ECU\">\n    <path d=\"M6 0V2H8V0H6ZM10 0V2H12V0H10ZM14 0V2H16V0H14ZM5 3C3.90694 3 3 3.90694 3 5V17C3 18.0931 3.90694 19 5 19H17C18.0931 19 19 18.0931 19 17V5C19 3.90694 18.0931 3 17 3H5ZM5 5H17V17H5V5ZM0 6V8H2V6H0ZM20 6V8H22V6H20ZM8 8V9V14H14V8H8ZM0 10V12H2V10H0ZM10 10H12V12H10V10ZM20 10V12H22V10H20ZM0 14V16H2V14H0ZM20 14V16H22V14H20ZM6 20V22H8V20H6ZM10 20V22H12V20H10ZM14 20V22H16V20H14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol